
import { TurretActor } from "./TurretActor";
import { AudioManager } from "../../../AudioManager";
import { GameVars } from "../../../GameVars";
import * as Creepts from "endless-siege-engine";

export class GlueTurretActor extends TurretActor {

    constructor(scene: Phaser.Scene, position: {r: number, c: number}, turret: Creepts.Turret) {

        super(scene, Creepts.GameConstants.TURRET_GLUE, position, turret);

        this.base = new Phaser.GameObjects.Image(this.scene, 0, -25, "texture_atlas_1", "crystal_1_base");
        this.base.setInteractive();
        this.base.on("pointerdown", this.onDownTurret, this);
        this.base.on("pointerover", this.onOverTurret, this);
        this.base.on("pointerout", this.onOutTurret, this);
        this.addAt(this.base, 0);

        this.canon = this.scene.add.sprite(0, -25, "texture_atlas_1", "crystal_1_top_01");
        this.canon.anims.play("crystal_top");
        this.add(this.canon);

        this.bringToTop(this.turretLevel);
    }

    public upgrade(): void {

        super.upgrade();

        switch (this.turret.grade) {

            case 2:
                this.base.setFrame("crystal_2_base");
                this.canon.anims.stop();
                this.canon.setFrame("crystal_2_top_01");
                break;
            case 3: 
                this.base.setFrame("crystal_3_base");
                this.canon.setFrame("crystal_3_top_01");
                break;
            default:
       }
    }

    public shootGlue(): void {

        if (this.turret.grade === 2) {
            AudioManager.playSoundEffect("t3_pegamento");

            this.scene.tweens.add({
                targets: this.canon,
                y: -15,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: GameVars.timeStepFactor === 1 ? 100 : 25,
                onComplete: () => {
                    
                    if (!this.scene) {
                        return;
                    }
                    
                    this.scene.tweens.add({
                        targets: this.canon,
                        y: -25,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: GameVars.timeStepFactor === 1 ? 100 : 25
                    });
                },
                onCompleteScope: this
            });
        } 
    }
}
